import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Dropdown, Popover } from 'rsuite';
import { icons } from '@shared/static/icons';
import { useShowToaster } from '@shared/ui/messages/useToaster';
import { useReferralsBalanceHistory } from '@utils/drawer-hooks';
import { copyToClipboard } from '@utils/helpers';

const ReferralsTableMobileMenu = forwardRef(({ close, ...rest }, ref) => {
  const { t } = useTranslation();
  const { statistic } = useSelector((state) => state.referrals);
  const showToaster = useShowToaster();
  const { openReferralsBalanceHistory } = useReferralsBalanceHistory();

  async function copyReferralLink() {
    await copyToClipboard(statistic?.referral_link ?? '');
    showToaster('success', t('referral_link_copied'));
  }

  return (
    <Popover ref={ref} {...rest} full>
      <Dropdown.Menu onSelect={close} className="dropdown-menu">
        <Dropdown.Item
          icon={icons.history}
          onSelect={openReferralsBalanceHistory}
        >
          {t('balance_history')}
        </Dropdown.Item>
        <Dropdown.Item icon={icons.copy} onSelect={copyReferralLink}>
          {t('copy_referral_link')}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Popover>
  );
});
ReferralsTableMobileMenu.displayName = 'ReferralsTableMobileMenu';

export default ReferralsTableMobileMenu;
